import React, { forwardRef, memo } from 'react'

const ExclusivePlatformShape = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 652 562"
    fill="none"
    {...props}>
    <path
      d="M538.063 198.343C538.063 88.801 449.262 0 339.72 0H0v396.687h339.72c109.542 0 198.343-88.802 198.343-198.344Z"
      fill="#EFF7E4"
    />
    <path
      d="M632.867 190.975c1.048-13.768-9.262-25.778-23.03-26.826L173.101 130.898c-13.767-1.048-25.777 9.263-26.826 23.03l-28.165 369.946 486.592 37.047 28.165-369.946Z"
      fill="#D9D9D9"
    />
    <path
      d="M146.275 153.928c1.049-13.767 13.059-24.078 26.826-23.03l94.726 7.212c13.767 1.048 24.078 13.058 23.03 26.826l-2.961 38.887-144.581-11.008 2.96-38.887Z"
      fill="#005F61"
    />
    <rect
      x={151.292}
      y={193.422}
      width={488}
      height={320.982}
      transform="rotate(4.354 151.292 193.422)"
      fill="#fff"
    />
    <path
      d="M154.252 154.535c1.048-13.767 13.059-24.078 26.826-23.03l436.736 33.251c13.767 1.048 24.078 13.058 23.03 26.826l-2.961 38.887-486.591-37.046 2.96-38.888Z"
      fill="#78BE20"
    />
    <rect
      x={181.934}
      y={146.613}
      width={229}
      height={34}
      rx={17}
      transform="rotate(4.354 181.934 146.613)"
      fill="#fff"
    />
    <path
      opacity={0.9}
      d="M213.661 163.011...L388.46 177.792Z"
      fill="#A0A0A0"
    />
    <circle
      cx={558.934}
      cy={183.014}
      r={7.676}
      transform="rotate(4.354 558.934 183.014)"
      fill="#fff"
    />
    <circle
      cx={582.689}
      cy={184.823}
      r={7.676}
      transform="rotate(4.354 582.689 184.823)"
      fill="#fff"
    />
    <circle
      cx={606.444}
      cy={186.632}
      r={7.676}
      transform="rotate(4.354 606.444 186.632)"
      fill="#fff"
    />
    <rect
      x={176.695}
      y={215.414}
      width={434}
      height={43}
      rx={12}
      transform="rotate(4.354 176.695 215.414)"
      fill="#CEDC00"
    />
    <rect
      x={170.015}
      y={303.16}
      width={434}
      height={196.199}
      rx={12}
      transform="rotate(4.354 170.015 303.16)"
      fill="#CEDC00"
    />
    <rect
      x={172.824}
      y={266.268}
      width={145}
      height={29}
      rx={12}
      transform="rotate(4.354 172.824 266.268)"
      fill="#CEDC00"
    />
    <rect
      x={325.382}
      y={277.883}
      width={281}
      height={29}
      rx={12}
      transform="rotate(4.354 325.382 277.883)"
      fill="#CEDC00"
    />
    <circle
      cx={170.024}
      cy={472.781}
      r={6.911}
      transform="rotate(4.354 170.024 472.781)"
      fill="#6C0CAE"
    />
    <circle
      cx={130.515}
      cy={445.515}
      r={27.643}
      transform="rotate(4.354 130.515 445.515)"
      fill="#6C0CAE"
    />
    <path
      d="M584.353 401.024...585.786 412.881L584.353 401.024Z"
      fill="#FFA300"
    />
    <path
      d="M627.069 367.118...628.148 376.052L627.069 367.118Z"
      fill="#FFA300"
    />
    <path
      d="M249.647 71.788c1.712-72.146 73.055-51.724 107.48-44.553-80.781-3.584-80.604 36.657-76.188 46.962l28.605 2.233-42.364 49.07-40.289-55.749 22.756 2.039Z"
      fill="#CEDC00"
    />
  </svg>
))

ExclusivePlatformShape.displayName = 'ExclusivePlatformShape'

export default memo(ExclusivePlatformShape)
